module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-automatorul.34ef4e71.jpg";